import { useEffect } from "react"
import { useAppDispatch } from "hooks"
import { getTenantByName } from "store/Tenant/tenant.slice"
import { envConfig } from "config"

const resolveTenantName = (hostname: string): string => {
	const parts = hostname.split(".")
	if (parts.length > 1) return parts[0]
	return ""
}

const GetTenantInformationWrapper: React.FC = () => {
	const dispatch = useAppDispatch()
	const environment = envConfig.environment.toLowerCase()

	useEffect(() => {
		if (environment === "prod") {
			const hostname = window.location.hostname.toLowerCase()
			const tenantName = resolveTenantName(hostname)
			dispatch(getTenantByName(tenantName))
		}
	}, [])

	return null
}

export default GetTenantInformationWrapper
